import React from 'react';
import { motion } from 'framer-motion';
import { LeafIcon, SparklesIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full bg-[#FBF9F4] overflow-hidden" data-id="element-186">
      {/* Decorative elements */}
      <div className="absolute top-10 left-10 text-[#5B8F7B]/20" data-id="element-187">
        <LeafIcon className="w-24 h-24 rotate-45" data-id="element-188" />
      </div>
      <div className="absolute bottom-20 right-10 text-[#5B8F7B]/20" data-id="element-189">
        <LeafIcon className="w-32 h-32 -rotate-12" data-id="element-190" />
      </div>

      <div className="relative max-w-6xl mx-auto px-4 py-16 md:py-24" data-id="element-191">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center" data-id="element-192">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-[#5B8F7B]/10 text-[#5B8F7B] px-4 py-2 rounded-full mb-8" data-id="element-193">
            <SparklesIcon className="w-4 h-4" data-id="element-194" />
            <span className="text-sm font-medium" data-id="element-195">
              Guía Premium de Bienestar
            </span>
          </div>

          {/* H1 */}
          <h1 className="font-['Playfair_Display'] text-3xl md:text-4xl lg:text-5xl font-bold text-[#2D3436] leading-tight mb-6 max-w-4xl mx-auto" data-id="element-196">
            El Protocolo "Vientre Plano Post-30": Cómo desactivar la inflamación
            por cortisol y recuperar tu cintura en 7 días.
          </h1>

          {/* H2 Subtitle */}
          <h2 className="font-['DM_Sans'] text-lg md:text-xl text-[#2D3436]/70 mb-12 max-w-2xl mx-auto" data-id="element-197">
            Sin dietas extremas, sin horas de cardio y sin gastar una fortuna en
            suplementos que no funcionan.
          </h2>

          {/* Product Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="mb-12" data-id="element-198">
            <img src="https://cdn.magicpatterns.com/uploads/gHP4t94BP1wbBqP8DVvLA3/PORTADA_OPCION_1.png" alt="Protocolo Vientre Plano Post-30 - Guía Digital mostrada en laptop, tablet y móvil" className="max-w-full md:max-w-3xl mx-auto rounded-2xl shadow-2xl shadow-[#5B8F7B]/20" data-id="element-199" />
          </motion.div>

          {/* CTA Button */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} data-id="element-200">
            <a href="#oferta" className="inline-block bg-gradient-to-r from-amber-500 to-amber-600 text-white font-semibold text-lg md:text-xl px-8 md:px-12 py-4 md:py-5 rounded-full shadow-lg shadow-amber-500/30 hover:scale-105 hover:shadow-xl hover:shadow-amber-500/40 transition-all duration-300" data-id="element-201">
              ¡SÍ, QUIERO DESINFLAMAR MI VIENTRE AHORA!
            </a>

            {/* Trust text */}
            <p className="mt-4 text-sm text-[#2D3436]/60" data-id="element-202">
              Acceso inmediato tras la compra. Pago 100% seguro.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}